import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=edb9e3fc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=edb9e3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb9e3fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edb9e3fc')) {
      api.createRecord('edb9e3fc', component.options)
    } else {
      api.reload('edb9e3fc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=edb9e3fc&scoped=true&", function () {
      api.rerender('edb9e3fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v7yTtA7zCrv9/JS/comp/CookieBox.vue"
export default component.exports